let React = require('react');
let InfiniteScroll = require('react-infinite-scroll')(React);
let ArticleCard = require('./articlecard');

let Articles = React.createClass({
  getInitialState: function() {
    return {
      loaded: false,
      entries: [],
      hasMore: false
    };
  },

  componentDidMount: function() {
    this.loadMore(0);
  },

  loadPage: function(page, cb){
    const filters = {
      page: page + 1,
      perpage: 5,
      type: 'article',
      order: 'DESC',
      sort: 'publish'
    };
    const tag = this.props.tag;
    if (tag) {
      filters.tag = tag;
    }
    const author = this.props.author;
    if (author) {
      filters.author = author;
    }
    apiConn.doCall('entryhandler', 'query', {filters}, (status, data) => {
      if (status) {
        cb(null, data);
      } else {
        cb('Failed to load entries.', null);
      }
    });
  },

  loadMore: function(page){
    this.loadPage(page, function(err, res) {
      if (err) {
        console.log('LOAD ERROR', err);
      } else {
        const entries = this.state.entries.concat(res.data);
        this.setState({
          entries,
          hasMore: ((res.total > entries.length) ? true : false),
          loaded: true
        });
      }
    }.bind(this));
  },

  loaderElement: function() {
    return (
      <div className="u-text-center">
        <img src="/public/assets/img/icons/loader.gif" alt="Loading" />
      </div>
    );
  },

  render() {
    const articles = this.state.entries.map((entry, index) => {
      return (
        <ArticleCard key={entry.id} id={'article_' + entry.id} card={entry} />
      );
    });

    if (articles.length) {
      return (
        <InfiniteScroll
          loader={this.loaderElement()}
          loadMore={this.loadMore}
          hasMore={this.state.hasMore}
        >
          { articles }
        </InfiniteScroll>
      );
    } else if (this.state.loaded) {
      return (
        <div className="u-width-one-whole">
          <div className="card card-article">
            <div className="u-padding-a-m">
              <h2 className="title-small u-text-center">{'Inga artiklar hittade.'}</h2>
            </div>
          </div>
        </div>
      );
    } else {
      return false;
    }
  }
});

module.exports = Articles;



// WEBPACK FOOTER //
// ./src/scripts/components/articles.js